import SearchList from './search-list';

export default SearchList;
